// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-07-28T05:59:34Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.eosp.controller.UserProfileController.
 */
export default class UserProfileApi {
    /**
     * 
     *
     * @param userId 
     * @return java.util.List<cz.marbes.api.ucet.v1.Autentizace>
     */
    static getLoginList(userId) {
        const uri = serverContextPath + `/api/eosp/profile/login-data/${userId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrati data o subjektech na ktere ma uzivatel pravo. Udaje ziskame z EOSP. @param userId guid uctu
     *
     * @param userId 
     * @return java.util.List<cz.marbes.eosp.controller.vo.SubjektDetailVO>
     */
    static getSubjektList(userId) {
        const uri = serverContextPath + `/api/eosp/profile/subjekty/${userId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param userId 
     * @param addChildrenToProfileVO 
     */
    static addChildrenToProfile(userId, addChildrenToProfileVO) {
        const uri = serverContextPath + `/api/eosp/profile/${userId}/addChildren`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, addChildrenToProfileVO, headers));
    }

    /**
     * 
     *
     * @param userId 
     * @param zadostId 
     */
    static stornoAccessRequest(userId, zadostId) {
        const uri = serverContextPath + `/api/eosp/profile/${userId}/pristupy/${zadostId}/storno`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param userId 
     * @param id 
     * @return java.lang.String
     */
    static downloadDokument(userId, id) {
        const uri = serverContextPath + `/api/eosp/profile/user-data/${userId}/dokumenty/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param userId 
     */
    static deleteUcet(userId) {
        const uri = serverContextPath + `/api/eosp/profile/user-data/${userId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param userId 
     * @param addPersonDataVO 
     */
    static addPersonToProfile(userId, addPersonDataVO) {
        const uri = serverContextPath + `/api/eosp/profile/${userId}/addPerson`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, addPersonDataVO, headers));
    }

    /**
     * 
     *
     * @param userId 
     * @param ico 
     */
    static addSelfEmployedToProfile(userId, ico) {
        const uri = serverContextPath + `/api/eosp/profile/${userId}/addSelfEmployed`;
        const headers = undefined;
        const params = { ico };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Vrati data o uzivateli, ktera se nachazi v EOSP. @param userId guid uctu
     *
     * @param userId 
     * @return cz.marbes.eosp.controller.vo.UserDataVO
     */
    static getUserProfile(userId) {
        const uri = serverContextPath + `/api/eosp/profile/user-data/${userId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrati data o subjektech na ktere ma uzivatel pravo.. @param userId guid uctu
     *
     * @param userId 
     * @return cz.marbes.eosp.controller.vo.PristupyZadostiVO
     */
    static getSubjektListExternal(userId) {
        const uri = serverContextPath + `/api/eosp/profile/subjekty/${userId}/external`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrati data o uzivateli, ktera se nachazi v PBO. @param userId guid uctu
     *
     * @param userId 
     * @return cz.marbes.eosp.controller.vo.UserDataVO
     */
    static getUserProfileExternal(userId) {
        const uri = serverContextPath + `/api/eosp/profile/user-data/${userId}/external`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param userId 
     * @param zadostId 
     * @param authorize 
     */
    static resolveAccessRequest(userId, zadostId, authorize) {
        const uri = serverContextPath + `/api/eosp/profile/${userId}/pristupy/${zadostId}`;
        const headers = undefined;
        const params = { authorize };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @return java.util.List<java.lang.Integer>
     */
    static findApplicationIds() {
        const uri = serverContextPath + `/api/eosp/profile/applicationIds`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
